import html2canvas from 'html2canvas'
import html2canvasFixSvg from 'html2canvas-fixsvg'
import { getTextWidth } from '../../helpers/common'
import { FORMAT, getCurrentDateTime } from '../../helpers/datetime'
import { getInnerHeight, getInnerWidth } from '../../helpers/device'

const INIT_WIDTH_IMAGE_LOGO = 100
const INIT_HEIGHT_IMAGE_LOGO = 25
const INIT_HEIGHT_TITLE = 50
const INIT_HEIGHT_SOURCE = 30
const INIT_PADDING_TOP_BOTTOM = 12
const INIT_PADDING_LEFT_RIGHT = 24
const INIT_MARGIN_LINE = 12

export const exportToImg = (
  logo,
  domId,
  exportName,
  titleJpg,
  source,
  fontSizeTitle,
  fontSizeSource,
  isFixSvg = false,
  ratio = 5,
) => {
  const image = new Image()
  image.src = logo
  image.crossOrigin = 'anonymous'

  const formExport = document.getElementById(domId)

  if (formExport) {
    const rectBound = formExport.getBoundingClientRect()
    const widthCut = rectBound.width
    const heightCut = rectBound.height
    const configCanvas = {
      allowTaint: true,
      useCORS: true,
      removeContainer: true,
      scale: ratio,
      logging: false,
      width: widthCut,
      height:
        heightCut +
        INIT_HEIGHT_IMAGE_LOGO +
        INIT_HEIGHT_TITLE +
        INIT_HEIGHT_SOURCE +
        INIT_PADDING_TOP_BOTTOM,
      backgroundColor: '#FFFFFF',
      windowWidth: getInnerWidth(),
      windowHeight: getInnerHeight(),
    }

    const htmlToCanvas = isFixSvg ? html2canvasFixSvg : html2canvas

    htmlToCanvas(formExport, {
      ...configCanvas,
      onclone: (document) => {
        Array.from(document.children[0].querySelectorAll('*')).forEach((e) => {
          if (e.tagName !== 'I' && e.parentNode?.tagName !== 'I') {
            e.setAttribute(
              'style',
              [
                'font-family: sans-serif !important',
                e.getAttribute('style') || '',
              ].join(';'),
            )
          } else {
            e.setAttribute(
              'style',
              [
                'font-family: fiingate !important',
                e.getAttribute('style') || '',
              ].join(';'),
            )
          }
        })
      },
    }).then((canvas) => {
      const canvasExport = document.createElement('canvas')
      const contextExport = canvasExport.getContext('2d')
      const WIDTH_IMAGE_LOGO = INIT_WIDTH_IMAGE_LOGO * ratio
      const HEIGHT_IMAGE_LOGO = INIT_HEIGHT_IMAGE_LOGO * ratio
      const HEIGHT_TITLE = titleJpg ? INIT_HEIGHT_TITLE * ratio : 0
      const HEIGHT_SOURCE = source ? INIT_HEIGHT_SOURCE * ratio : 0
      const PADDING_TOP_BOTTOM = INIT_PADDING_TOP_BOTTOM * ratio
      const PADDING_LEFT_RIGHT = INIT_PADDING_LEFT_RIGHT * ratio
      const MARGIN_LINE = INIT_MARGIN_LINE * ratio
      const CANVAS_PADDING_BOTTOM = 15 // to resolve case different between bottom of platform and img

      canvasExport.width = widthCut * ratio + 2 * PADDING_LEFT_RIGHT
      canvasExport.height =
        heightCut * ratio +
        HEIGHT_IMAGE_LOGO +
        HEIGHT_TITLE +
        HEIGHT_SOURCE +
        PADDING_TOP_BOTTOM +
        CANVAS_PADDING_BOTTOM

      contextExport.fillStyle = '#FFFFFF'
      contextExport.fillRect(0, 0, canvasExport.width, canvasExport.height)

      contextExport.drawImage(
        canvas,
        PADDING_LEFT_RIGHT,
        HEIGHT_IMAGE_LOGO + HEIGHT_TITLE,
      )

      contextExport.drawImage(
        image,
        PADDING_LEFT_RIGHT,
        PADDING_TOP_BOTTOM,
        WIDTH_IMAGE_LOGO,
        HEIGHT_IMAGE_LOGO,
      )

      drawLine(
        contextExport,
        PADDING_LEFT_RIGHT + WIDTH_IMAGE_LOGO + MARGIN_LINE,
        PADDING_TOP_BOTTOM + HEIGHT_IMAGE_LOGO / 2,
        canvasExport.width - PADDING_LEFT_RIGHT,
        PADDING_TOP_BOTTOM + HEIGHT_IMAGE_LOGO / 2,
        0.5 * ratio,
      )

      if (titleJpg) {
        const fontWeight = 600
        contextExport.globalAlpha = 0
        contextExport.fillRect(
          0,
          HEIGHT_IMAGE_LOGO + PADDING_TOP_BOTTOM,
          canvasExport.width,
          HEIGHT_TITLE,
        )
        contextExport.globalAlpha = 1
        contextExport.fillStyle = '#191D25'
        contextExport.font = `${fontWeight} ${
          fontSizeTitle * ratio
        }px SFProDisplay`
        contextExport.textBaseline = 'top'
        contextExport.textAlign = 'center'
        contextExport.fillText(
          titleJpg,
          canvasExport.width / 2,
          HEIGHT_TITLE / 2 +
            HEIGHT_IMAGE_LOGO +
            PADDING_TOP_BOTTOM -
            (fontSizeTitle * ratio) / 2,
        )
      }

      if (source) {
        const fontWeight = 400
        contextExport.fillStyle = '#FFFFFF'
        contextExport.fillRect(
          0,
          canvasExport.height - HEIGHT_SOURCE,
          canvasExport.width,
          HEIGHT_SOURCE,
        )
        contextExport.fillStyle = '#3A414B'
        contextExport.font = `${fontWeight} italic ${
          fontSizeSource * ratio
        }px SFProDisplay`
        contextExport.textBaseline = 'top'
        contextExport.textAlign = 'center'
        const width = getTextWidth(source, fontSizeSource * ratio, fontWeight)
        contextExport.fillText(
          source,
          canvasExport.width - width / 2 - PADDING_LEFT_RIGHT,
          canvasExport.height -
            HEIGHT_SOURCE / 2 -
            (fontSizeSource * ratio) / 2,
        )

        drawLine(
          contextExport,
          PADDING_LEFT_RIGHT,
          canvasExport.height - HEIGHT_SOURCE / 2,
          canvasExport.width - PADDING_LEFT_RIGHT - width - MARGIN_LINE,
          canvasExport.height - HEIGHT_SOURCE / 2,
          0.5 * ratio,
        )
      }

      document.body.appendChild(canvasExport)

      const downloadLink = document.createElement('a')

      const data = canvasExport.toDataURL('image/jpg')
      formExport.appendChild(downloadLink)
      downloadLink.setAttribute('download', exportName)
      downloadLink.setAttribute('href', data)
      downloadLink.click()
      formExport.removeChild(downloadLink)
      document.body.removeChild(canvasExport)
    })
  }
}

const drawLine = (contextExport, x1, y1, x2, y2, lineWidth) => {
  contextExport.beginPath()
  contextExport.setLineDash([15, 15])
  contextExport.lineWidth = lineWidth
  contextExport.strokeStyle = '#555555'
  contextExport.moveTo(x1, y1)
  contextExport.lineTo(x2, y2)
  contextExport.stroke()
}

export const handleNameFileDownload = (arrName, timezone) => {
  const results = ['FG'].concat(arrName)

  results.push(getCurrentDateTime(FORMAT.FILE_DOWNLOAD, undefined, timezone))

  return results.join('_')
}
